import React, { useContext, useState } from 'react';
import Form from '../../..';
import * as S from './styled';
import DateFilter from '../../../../DateFilter';
import { setFilterColumn } from '../../../../../store/utils';
import { ExportContext } from '../../../../../provider/ExportProvider';
import { createTrue } from 'typescript';

export default function FormDepositFilter() {
  const {
    getAutocompleteItems,
    setAutocompleteItems,
    getFilterField,
    setField,
    setSearchFilter,
    searchFilter,
    setInvoice,
    setFilterField,
    depositGroups,
    selectedGroupId,
  } = useContext(ExportContext)!.controllers.deposit;

  const getItems = (field: keyof InvoiceState['autocompletes']['deposits']) =>
    getAutocompleteItems(field);

  const [companyLoading, setCompanyLoading] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);

  const autocompleteCompanies = () => {
    setCompanyLoading(true);
    setAutocompleteItems('company').finally(() => {
      setCompanyLoading(false);
    });
  };

  const autocompleteGroups = () => {
    setGroupLoading(true);
    setAutocompleteItems('group').finally(() => {
      setGroupLoading(false);
    });
  };

  const lockedFilter = getFilterField('locked');
  const [lockLabel, setLockLabel] = useState(
    lockedFilter === true
      ? 'BLOQUEADO'
      : lockedFilter === false
        ? 'DESBLOQUEADO'
        : '',
  );
  const lockItems = [
    {
      id: 0,
      name: 'DESBLOQUEADO',
      data: false,
    },
    {
      id: 1,
      name: 'BLOQUEADO',
      data: true,
    },
  ];

  return (
    <S.Form>
      <S.Body>
        <S.BodyContainer>
          {!selectedGroupId && (depositGroups.length > 1) ? (
            <S.Field>
              <Form.Input.Dropdown
                label="Grupo"
                value={getFilterField('group') as string}
                onChange={setField('group')}
                items={getItems('group')}
                errorMessage={false}
                onSelected={(item) => {
                  setField('group')({
                    target: {
                      value: `${item.name}`,
                    },
                  });
                }}
                onDebouncedChange={autocompleteGroups}
                onFocus={() => {
                  setField('group')({
                    target: {
                      value: '',
                    },
                  });
                }}
                hasClearItem
                loading={groupLoading}
              />
            </S.Field>
          ) : null}

          <S.Field>
            <Form.Input.Dropdown
              label="Companhia"
              value={getFilterField('company') as string}
              onChange={setField('company')}
              items={getItems('company')}
              errorMessage={false}
              onSelected={(item) => {
                setField('company')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteCompanies}
              onFocus={() => {
                setField('company')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={companyLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Status"
              value={lockLabel}
              errorMessage={false}
              onChange={(e) => {
                const value = e.target.value;
                const selectedItem = lockItems.find(
                  ({ name }) => value === name,
                );
                if (selectedItem) {
                  setFilterField(
                    'locked',
                    'EQUAL',
                  )({
                    target: {
                      value: selectedItem.data,
                    },
                  });
                }
                setLockLabel(value);
              }}
              items={lockItems}
              onSelected={(item) => {
                setFilterField(
                  'locked',
                  'EQUAL',
                )({
                  target: {
                    value: item.data,
                  },
                });
              }}
              onFocus={() => {
                setFilterField(
                  'locked',
                  'EQUAL',
                )({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
            />
          </S.Field>

          <S.DateContainer>
            <S.Label>Data do depósito</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('date', 'GEQ') as string}
                onChange={setField('date', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('date', 'LT') as string}
                onChange={setField('date', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('date', 'GEQ') as string}
              finalDate={getFilterField('date', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'date',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('date', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de referência</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('reference', 'GEQ') as string}
                onChange={setField('reference', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('reference', 'LT') as string}
                onChange={setField('reference', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('reference', 'GEQ') as string}
              finalDate={getFilterField('reference', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'reference',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('reference', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de criação</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('createdAt', 'GEQ') as string}
                onChange={setField('createdAt', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('createdAt', 'LT') as string}
                onChange={setField('createdAt', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('createdAt', 'GEQ') as string}
              finalDate={getFilterField('createdAt', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'createdAt',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('createdAt', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de atualização</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('updatedAt', 'GEQ') as string}
                onChange={setField('updatedAt', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('updatedAt', 'LT') as string}
                onChange={setField('updatedAt', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('updatedAt', 'GEQ') as string}
              finalDate={getFilterField('updatedAt', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'updatedAt',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('updatedAt', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>
        </S.BodyContainer>
      </S.Body>
      <S.ClearButton
        onClick={(e) => {
          e.preventDefault();
          setInvoice('filters.deposits.filter.filter', []);
          setLockLabel('');
        }}
      >
        Limpar
      </S.ClearButton>
    </S.Form>
  );
}
